// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './vuex';

import * as timeGadgets from './gadgets/timeGadgets';
import filters from './gadgets/filters';
import dataRow from './components/dataRow';

import MintUI from 'mint-ui';

// import VConsole from 'vconsole';

// new VConsole();

Vue.use(MintUI);

Vue.prototype.$indicator = MintUI.Indicator;
Vue.prototype.$toast = MintUI.Toast;
Vue.prototype.$messageBox = MintUI.MessageBox;
// Vue.prototype.$popup  = MintUI.Popup ;

Vue.prototype.$datetimeFormatter = timeGadgets.datetimeFormatter;
Vue.prototype.$dateFormatter = timeGadgets.dateFormatter;
Vue.prototype.$monthFormatter = timeGadgets.monthFormatter;
Vue.prototype.$today = timeGadgets.getToday;

Vue.prototype.$timeGadgets = timeGadgets;

Vue.component('dataRow', dataRow);



Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
// 初始化上报
try {
  window.rfReport = new RfReport({
    domain: location.hostname.search('wallet.thinkinpower.com') === 0 ? 'https://act.thinkinpower.com/analytics' : 'https://act.test.thinkinpower.net/analytics',
    isAutoReport: false,
    autoTime: 10 * 1000,
    debugger: location.hostname.search('wallet.thinkinpower.com') === 0 ? false : true,
    isUse: true,
    // ajax请求时需要过滤的url信息
    filterUrl: ['list_user_download', 'rfpay_report/pay/account/list'],
    // 是否上报页面性能数据
    isPage: true,
    // 是否上报ajax性能数据
    isAjax: false,
    // 是否上报页面资源数据
    isResource: false,
    // 是否上报错误信息
    isError: true,
    isDebugger: true,
    // 是否延迟上报
    isDelayReport: true,
    config: {
      app_id: '74e168ad5cc790520dad812e3e595b04',
      module: 'PLATFORM_H5_WALLET',
    }
  })
} catch (error) {
  console.log('实例化上报', error)
}
router.beforeEach((to, from, next) => {
  try {
    window.rfReport.reportData()
  } catch (error) {
    console.log('rfReport路由守卫报错====>', error);
  }

  // MintUI.Indicator.open()
  // debugger
  // 为了满足通联回跳的一堆BUG，所以针对部分通联回跳行为进行hack，使其正常
  const cbMethod = to.query.cbMethod ? to.query.cbMethod : ''
  //   const wallet_level = to.query.wallet_level ? to.query.wallet_level : ''

  if (to.name !== "withdrawSuccess" && cbMethod.search('withdrawSuccess') > -1) {
    next({
      name: 'withdrawSuccess'
    })
  } else {
    // to.query
    next()
  }

});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js